import "@react-three/fiber"
import styled from "styled-components"
import { BasicBox } from "./BasicBox"
import { state } from "../state"

interface BoxProps {
  width: number
  hideBackground?: boolean
}

const Box = styled(BasicBox)<BoxProps>`
  cursor: pointer;
  width: ${(p) => p.width}px;
  color: white;
`

export function GreenList(props: any) {
  return (
    <Box
      {...props}
      onClick={() => {
        if (props.nextStep) {
          props.setStep(props.nextStep)
        }
      }}
    >
      <p>
        Your country (
        <strong className="detail">{state.geoData?.country}</strong>) is on the{" "}
        <em className="green">GREEN LIST</em>. You are permitted to view content
        on this site without restriction. Please continue.
      </p>
    </Box>
  )
}
